import { dataTransferWrap } from '../dataTransferService'

import dtConfig from '@/config/data-transfer'
import { ModulesMap } from '@/config/data/modulesMaps'

function getFuelStationRawEvents(companyId, query) {
  return dataTransferWrap(
    ModulesMap.FUEL_STATION_RAW_EVENTS,dtConfig[ModulesMap.FUEL_STATION_RAW_EVENTS].getFuelStationRawEvents,
    {
      urlParams: {
        companyId,
      },
      params: query,
    },

  )
}

function getFuelStationRawEvent(companyId, rawEventId, data) {
  return dataTransferWrap(ModulesMap.FUEL_STATION_RAW_EVENTS,dtConfig[ModulesMap.FUEL_STATION_RAW_EVENTS].getFuelStationRawEvent, {
    urlParams: {
      companyId,
      rawEventId,
    },
    ...data,
  })
}

function getFuelStationRawEventPreview(companyId, rawEventId, data) {
  return dataTransferWrap(ModulesMap.FUEL_STATION_RAW_EVENTS,dtConfig[ModulesMap.FUEL_STATION_RAW_EVENTS].getFuelStationRawEventPreview, {
    urlParams: {
      companyId,
      rawEventId,
    },
    ...data,
  })
}

export default {
  getFuelStationRawEvents,
  getFuelStationRawEvent,
  getFuelStationRawEventPreview,
}
